import { combineReducers } from "redux";
import { intlReducer } from "react-intl-redux";
import actiontypes from "./actions/actiontypes";
import CryptoJS, { SHA1 } from "crypto-js";
import { unknownErrorException } from "./sagas/handleError";

function loginForm(state, action) {
    let newState = { ...state };
    newState.signup ??= {
        isActive: false,
        isSubmitting: false,
        flowStage: null,
        message: "",
    };
    newState.emailAutoLinkData ??= {
        status: "idle",
        data: null,
        error: null,
    };
    newState.loginErrorMessages = [];
    newState.successMessages = [];
    newState.translatableMessages = [];
    newState.isFetching = false;
    let messageVariant;
    switch (action.type) {
        case actiontypes.SET_FETCHING:
            newState.isFetching = action.payload === true;
            return newState;
        case actiontypes.TRANSLATABLE_SUCCESS_MESSAGE:
            messageVariant ??= "success";
            // Falls through
        case actiontypes.TRANSLATABLE_ERROR_MESSAGE:
            messageVariant ??= "error";
            newState.translatableMessages.push({
                key: SHA1(JSON.stringify({...action.payload, time: Date.now()})).toString(CryptoJS.enc.Hex),
                message: action.payload,
                options: {variant: messageVariant}
            });
            return newState;
        case actiontypes.USER_GET_PROVIDER:
            newState.isFetching = true;
            return { ...newState, username: action.payload.username };
        case actiontypes.SET_S1_TRANSPORT:
            return { ...newState, s1TransportUser: action.payload };
        case actiontypes.SET_PROVIDER:
            newState.isFetching = false;
            return { ...newState, provider: action.payload };
        case actiontypes.USER_LOGIN:
            newState.signup.message = "";
            //newState.signup.flowStage = null;
            newState.flowParameter = action.payload.flowParameter ?? "login";
            if (action.payload.username && action.payload.password) {
                newState.username = action.payload.username.trim().toLowerCase();
                newState.password = action.payload.password.trim();
            }
            if (action.payload.accountNumber) {
                newState.accountNumber = action.payload.accountNumber.trim().toLowerCase();
            }
            if (action.payload.email) {
                newState.email = action.payload.email.trim().toLowerCase();
            }
            newState.isPreAuth = true;
            newState.isFetching = true;
            return newState;
        case actiontypes.USER_SIGNUP_SET_ACTIVE:
            newState.signup.isActive = action.payload === true;
            if (!newState.signup.isActive) {
                newState.signup.message = "";
                newState.signup.flowStage = null;
            }
            return { ...newState };
        case actiontypes.USER_SIGNUP:
            newState.isFetching = true;
            newState.signup.isSubmitting = true;
            newState.signup.message = "";
            newState.signup.flowStage = null;
            if (action.payload.username) {
                newState.signup.username = action.payload.username.trim();
            }
            if (action.payload.password) {
                newState.signup.password = action.payload.password.trim();
            }
            if (action.payload.accountNumber) {
                newState.signup.accountNumber = action.payload.accountNumber.trim();
            }
            if (action.payload.email) {
                newState.signup.email = action.payload.email.trim();
            }
            return { ...newState };
        case actiontypes.EMAIL_AUTO_LINK:
            newState.isFetching = true;
            newState.emailAutoLinkData.status = "loading";
            newState.emailAutoLinkData.users = null;
            newState.emailAutoLinkData.error = null;
            return { ...newState };
        case actiontypes.EMAIL_AUTO_LINK_NEEDED:
            newState.emailAutoLinkData.status = "needed";
            return { ...newState };
        case actiontypes.EMAIL_AUTO_LINK_HANDLE_RESULT:
            newState.isFetching = false;
            newState.emailAutoLinkData.status = "pending";
            newState.emailAutoLinkData.users = action.payload;
            newState.emailAutoLinkData.error = null;
            return { ...newState };
        case actiontypes.EMAIL_AUTO_LINK_SUCCESS:
            newState.isFetching = false;
            newState.emailAutoLinkData.status = "success";
            newState.emailAutoLinkData.error = null;
            return { ...newState };
        case actiontypes.EMAIL_AUTO_LINK_FAILURE:
            newState.isFetching = false;
            newState.emailAutoLinkData.status = "error";
            newState.emailAutoLinkData.users = null;
            newState.emailAutoLinkData.error = true;
            return { ...newState };
        case actiontypes.USER_SIGNUP_SUCCESS:
            newState.isFetching = false;
            newState.signup.isSubmitting = false;
            newState.signup.flowStage = "SIGNUP_COMPLETE";
            newState.signup.message = action.payload?.message ?? "";
            newState.password = "";
            newState.accountNumber = "";
            if (action.payload?.returnToLogin === true) {
                newState.signup.isActive = false;
            }
            return { ...newState };
        case actiontypes.USER_SIGNUP_FAILURE:
            newState.isFetching = false;
            newState.signup.isSubmitting = false;
            newState.signup.flowStage = action.payload?.flowStage ?? null;
            newState.signup.message = action.payload?.message ?? "";
            return { ...newState };
        case actiontypes.USER_LOGIN_LEGACY:
            if (action.payload.username && action.payload.password) {
                newState.username = action.payload.username.trim().toLowerCase();
                newState.password = action.payload.password.trim();
            }
            newState.isFetching = true;
            return newState;
        case actiontypes.USER_LOGIN_ERROR:
            newState.loginErrorMessages.push({
                key: SHA1(JSON.stringify({payload:action.payload, time: Date.now()})).toString(CryptoJS.enc.Hex),
                message: action.payload
            });
            return {...newState};
        case actiontypes.MFA_REQUIRED:
            newState.totpSpinning = false;
            newState.flowStage = action.payload.challengeName;
            newState.cognitoUser = action.payload.cognitoUser;
            return newState;
        case actiontypes.USER_LOGIN_SUCCESS:
            newState.isPreAuth = false;
            newState.isFetching = true;
            newState.authToken = action.payload.idToken
            newState.refreshToken = action.payload.refreshToken
            return newState;
        case actiontypes.SAVE_COGNITO_USER:
            newState.cognitoUser = action.payload;
            return newState;
        case actiontypes.USER_LOGIN_HANDLE_PREAUTH_CHALLENGE:
            newState.successMessages = []
            newState.flowStage = action.payload.challengeName;
            newState.totpSpinning = false;
            if (action.payload.challengeName || action.payload.challengeParameters) {
                newState.challenge = action.payload;
            }
            if (action.payload.userAttributes) {
                newState.UserAttributes = action.payload.userAttributes;
            }
            return newState;
        case actiontypes.USER_LOGIN_HANDLE_CHALLENGE:
            if (action.payload.userInfo) {
                newState.userInfo = {
                    UserAttributes: action.payload.userInfo.UserAttributes.reduce(function (object, item) {
                        object[item.Name] = item.Value;
                        return object;
                    }, {})
                }
            }
            
            if (!action.payload.keepFlowStage) {
                newState.flowStage = action.payload.challenge.challengeName;
            }
            
            newState.challenge = action.payload.challenge;
            if (action.payload.challenge.challengeParameters["SECRET_CODE"]) {
                newState.secretCode = action.payload.challenge.challengeParameters["SECRET_CODE"];
            }
            if (action.payload.challenge.challengeParameters["TOTP_SESSION"]) {
                newState.totpSession = action.payload.challenge.challengeParameters["TOTP_SESSION"];
            }
            newState.totpSpinning = false;
            return newState;
        case actiontypes.USER_LOGIN_FLOW_STAGE:
            newState.flowStage = action.payload.flowStage;
            return newState;
        case actiontypes.USER_RESET_PASSWORD: {
            newState.isFetching = true;
            return { ...newState };
        }
        case actiontypes.USER_CHANGE_PASSWORD: {
            newState.isFetching = true;
            newState.password = action.payload.newPassword;
            return { ...newState };
        }
        case actiontypes.USER_CHANGE_PASSWORD_RESPONSE: {
            newState.isFetching = false;
            if (action.payload.flowStage) {
                newState.flowStage = action.payload.flowStage;
            }
            if (action.payload.challenge) {
                newState.challenge = action.payload.challenge;
            }
            if (action.payload.status) {
                if (action.payload.status === "success") {
                    newState.successMessages.push(action.payload.message);
                }
                if (action.payload.status === "error") {
                    newState.loginErrorMessages.push(action.payload.message);
                }
            }
            return { ...newState };
        }
        case actiontypes.USER_RESET_PASSWORD_RESPONSE: {
            newState.flowStage = action.payload.flowStage;
            newState.step = action.payload.flowStage;
            newState.challenge = action.payload.challenge;
            newState.isFetching = false;
            if (action.payload.status) {
                if (action.payload.status === "success") {
                    newState.successMessages.push(action.payload.message);
                }
                if (action.payload.status === "error") {
                    newState.loginErrorMessages.push(action.payload.message);
                }
            }
            return { ...newState };
        }
        case actiontypes.USER_RESET_PASSWORD_CANCEL: {
            newState.flowStage = "LOGIN"
            delete newState.step;
            return { ...newState };
        }
        case actiontypes.TOTP_SPINNING: {
            newState.totpSpinning = true;
            return { ...newState };
        }
        case actiontypes.REMOVE_PROVIDER:
            newState.provider = "";
            newState.username = "";
            return { ...newState };
        case actiontypes.SET_USERNAME:
            newState.username = action.payload;
            newState.password = "";
            return { ...newState };
        case actiontypes.SET_PASSWORD:
            newState.password = action.payload.trim();
            return { ...newState };
        case actiontypes.SET_ACCOUNT_NUMBER:
            newState.accountNumber = action.payload.trim();
            return { ...newState };
        case actiontypes.SET_EMAIL:
            newState.email = action.payload.trim();
            return { ...newState };
        case actiontypes.REMEMBER_ME:
            if (!newState.remembered) {
                newState.remembered = true;
            } else {
                newState.remembered = false
            }
            return { ...newState };
        case actiontypes.SET_DEVICE_DATA: {
            // TODO Device saving COR-1814
            if (state.saveDevice) {
                const username = action.payload.username.toLowerCase();
                newState.device[username] = {
                    deviceKey: action.payload.deviceKey,
                    deviceGroupKey: action.payload.deviceGroupKey,
                    devicePassword: action.payload.devicePassword,
                    expires: action.payload.expires
                }
            }
            return { ...newState }
        }
        case actiontypes.SAVE_DEVICE: {
            // TODO Device saving COR-1814
            newState.saveDevice = action.payload === true;
            return { ...newState };
        }
        case actiontypes.MFA_SET_SMS_NUMBER: {
            newState.mfa.sms ??= {};
            newState.mfa.sms.value = action.payload;
            newState.mfa.sms.enabled = true;
            return { ...newState };
        }
        case actiontypes.MFA_SET_EMAIL: {
            newState.mfa.email ??= {};
            newState.mfa.email.value = action.payload;
            newState.mfa.email.enabled = true;
            return { ...newState };
        }
        case actiontypes.MFA_ENABLE_CHOICE: {
            newState.mfa[action.payload.id].enabled = action.payload.value;
            return { ...newState };
        }
        case actiontypes.SET_MFA_TYPE_SETUP_COMPLETE:
        case actiontypes.MFA_SKIP: {
            newState.mfaComplete.push(action.payload);
            return { ...newState };
        }
        case actiontypes.MANUAL_LINK_ACCOUNT:
            newState.isFetching = true;
            if (action.payload?.itemKey && Array.isArray(newState.emailAutoLinkData.users)) {
                const itemIndex = newState.emailAutoLinkData.users.findIndex(item => item.key === action.payload.itemKey);
                if (itemIndex >= 0) {
                    newState.emailAutoLinkData.users[itemIndex] = {
                        ...newState.emailAutoLinkData.users[itemIndex],
                        linkStatus: "linking",
                        linkError: null,
                    };
                }
            }
            return { ...newState };
        case actiontypes.MANUAL_LINK_ACCOUNT_SUCCESS:
            newState.isFetching = false;
            if (action.payload?.itemKey && Array.isArray(newState.emailAutoLinkData.users)) {
                const itemIndex = newState.emailAutoLinkData.users.findIndex(item => item.key === action.payload.itemKey);
                if (itemIndex >= 0) {
                    const expectedUsername = String( action.payload?.username ?? "").trim().toLowerCase();
                    const expectedClientId = String(action.payload?.clientId ?? "").trim();
                    const responseItems = Array.isArray(action.payload?.response) ? action.payload.response : [];
                    const matchedAccount = responseItems
                        .filter(responseItem => Array.isArray(responseItem?.applicationAccounts) && responseItem.applicationAccounts.length > 0)
                        .flatMap(responseItem => {
                            return responseItem.applicationAccounts.map(applicationAccount => ({
                                applicationAccount,
                                fallbackClientId: responseItem?.application?.clientId,
                            }));
                        })
                        .find(({ applicationAccount, fallbackClientId }) => {
                            const accountUsername = String(applicationAccount?.applicationLoginName ?? "").trim().toLowerCase();
                            const accountClientId = String(applicationAccount?.client_id ?? fallbackClientId ?? "").trim();
                            return accountUsername === expectedUsername && accountClientId === expectedClientId;
                        });

                    newState.emailAutoLinkData.users[itemIndex] = {
                        ...newState.emailAutoLinkData.users[itemIndex],
                        linked: Boolean(matchedAccount),
                        linkStatus: matchedAccount ? "linked" : "error",
                        linkError: matchedAccount ? null : unknownErrorException,
                    };
                }
            }
            return { ...newState };
        case actiontypes.MANUAL_LINK_ACCOUNT_FAILURE:
            newState.isFetching = false;
            if (action.payload?.itemKey && Array.isArray(newState.emailAutoLinkData.users)) {
                const itemIndex = newState.emailAutoLinkData.users.findIndex(item => {
                    return item.key === action.payload.itemKey;
                });
                if (itemIndex >= 0) {
                    newState.emailAutoLinkData.users[itemIndex] = {
                        ...newState.emailAutoLinkData.users[itemIndex],
                        linked: false,
                        linkStatus: "error",
                        linkError: action.payload?.linkError,
                    };
                }
            }
            return { ...newState };
        default:
            return { ...newState };
    }
}

export default combineReducers({
    intl: intlReducer,
    loginForm,
});
